import ApiFetch from 'utils/apiFetch';
import { buildNotificationQuery } from './query';

const ApiFetchInstance = ApiFetch();

export const URLS = {
  list: '/notifications',
  detail: (id) => `/notifications/${encodeURIComponent(id)}`,
};

export default {
  getNotifications({ page = 0, category = '', search = '' } = {}) {
    const query = buildNotificationQuery({ page, category, search });
    return ApiFetchInstance.get(`${URLS.list}?${query}`);
  },
  getNotification(id) {
    return ApiFetchInstance.get(URLS.detail(id));
  },
};
